import APIv2 from './APIv2'
import {INFORMATION_MODAL_API} from '../constants/Constants'

export function getInformationModal() {
    return APIv2.requestData({
        name: 'information_modal',
        method: 'GET',
        url: `${INFORMATION_MODAL_API}`,
    })
}
